const awsmobile = {
  aws_project_region: 'us-east-1',
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_ombqQrEPE',
  aws_user_pools_web_client_id: 'v19i1vr87il61pmhoq27gfb4f',
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_verification_mechanisms: ['EMAIL'],
};
export default awsmobile;
